

import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../../components/Button/Button';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import "../Query/Query.css";
import { FaEye } from 'react-icons/fa';
import Input from '../../components/Input/Input';
import { Link } from 'react-router-dom';

const StakeHolderQueryForm = ({ attachment, attachmentLoader, query_details, setReplyAttachment, query_id, query_reply, handleSubmit, handleChange, removeReplyAttachmentHandler }) => {

  return (
    <React.Fragment>
      <div className='d-flex justify-content-between'>
        <span className='query-type text-capitalize'>Query No. {query_id}</span>
      </div>
      <div className="query-container" style={{ backgroundColor: "rgb(238 232 232)" }}>
        <div className='query-message'>
          <span>{query_details.details}</span>
        </div>
      </div>
      {attachmentLoader ? <span>Loading...</span> :
        <span>{attachment ?
          <Link onClick={() => window.open(attachment)}>View Attachment:
            <FaEye /></Link> : ""}
        </span>
      }
      <span>
        {
          query_details.replies && query_details.replies.length > 0 && query_details.replies[0].reply_attachment && (
            <div className="mt-2">
              <Link onClick={() => window.open(query_details.replies[0].reply_attachment)}>View Reply Attachment: <FaEye /></Link>
              <i className="fa-solid fa-xmark p-2"
                style={{ color: 'var(--color-danger-text)', cursor: 'pointer', fontSize: "20px" }}
                onClick={() => removeReplyAttachmentHandler(query_id, query_details.replies[0].id)}
              ></i>
            </div>
          )
        }
      </span>
      <Form onSubmit={handleSubmit}>
        <div className="row mt-4">
          <div className="col-md-12 mt-2">
            <Input
              type="file"
              name="reply_attachment"
              id="reply_attachment"
              placeholder={"Reply Attachment"}
              onChangeHandler={(e) => setReplyAttachment(e.target.files[0])}
              accept="image/*,application/pdf"
              multiple={false}
            />
          </div>
          <div className="col-md-12 mt-2">
            <Form.Group>
              <Form.Label>Reply</Form.Label>
            </Form.Group>
            <CKEditor
              editor={ClassicEditor}
              data={query_reply}
              onChange={(event, editor) => {
                const data = editor.getData();
                handleChange({ target: { name: 'query_reply', value: data } });
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end mt-2">
          <Button variant="secondary"
            onClick={(e) => {
              handleSubmit(e, 0);
            }}
            className='mx-1'>Send</Button>
          <Button variant="warning" onClick={(e) => {
            handleSubmit(e, 1);
          }}>Save as Draft</Button>
        </div>
      </Form>
    </React.Fragment>
  );
};
export default StakeHolderQueryForm;
